import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Themhanghoatonghop from "components/Duongsat/Themhanghoatonghop.js";
import Capnhathanghoatonghop from "components/Duongsat/Capnhathanghoatonghop.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import dayjs from "dayjs";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const txcolumn = [
  {
    field: "thang",
    headerName: "Tháng báo cáo",
    width: 220,
    headerAlign: "center",
  },
  {
    field: "sanluonghhvanchuyen",
    headerName: "Sản lượng vận chuyển",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "sanluonghhluanchuyen",
    headerName: "Sản lượng luân chuyển",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "sovoicungky",
    headerName: "So với cùng kỳ (%)",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "ngaycn",
    headerName: "Ngày cập nhật",
    width: 150,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "ten_nguoicn",
    headerName: "Người cập nhật",
    width: 150,
    headerAlign: "center",
  },
];
export default function Hanghoatonghop() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [openthem, setOpenthem] = React.useState(false);
  const [thangnam, setThangnam] = React.useState(dayjs());
  const [nam, setNam] = React.useState(new Date().getFullYear());
  const [baocao, setBaocao] = React.useState([]);
  const [thangbaocao, setThangbaocao] = React.useState("");
  const [disableBT, setDisableBT] = React.useState(true);
  const [opensua, setOpensua] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const handleClose = () => {
    setOpenthem(false);
    getbaocao(nam);
  };
  const handleClosesua = () => {
    setOpensua(false);
    getbaocao(nam);
  };
  const openthemtx = () => {
    setOpenthem(true);
    setDisableBT(true); // fix delete button
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = (nambc) => {
    setDisableBT(true); // fix delete button
    var url =
      Config.backend +
      "/api/Donvi/getslthduongsathhnam?nam=" +
      nambc +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setBaocao(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoabaocao = () => {
    var url = Config.backend + "/api/Donvi/xoaslthduongsathh";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        thang: thangbaocao,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
          getbaocao(nam);
          setDisableBT(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  React.useEffect(() => {
    getbaocao(nam);
  }, []);
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn năm"
              value={thangnam}
              onChange={(newValue) => {
                setNam(newValue.$y);
                setThangnam(newValue);
                getbaocao(newValue.$y);
              }}
              format="YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "27px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 27 }}
            onClick={openthemtx}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="error"
            variant="contained"
            style={{ height: 27 }}
            disabled={disableBT}
            onClick={xoabaocao}
          >
            Xóa
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.thang}
            rows={baocao}
            columns={txcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              setDisableBT(false);
              setThangbaocao(params.row.thang);
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setOpensua(true);
                setDisableBT(true); // fix delete button
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm báo cáo hàng hóa
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themhanghoatonghop />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opensua}
          onClose={handleClosesua}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật báo cáo hàng hóa
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosesua} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhathanghoatonghop thang={thangbaocao} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
